import React, { FC, ReactElement, ReactNode, useMemo, useState } from 'react';
import { TooltipBody, TooltipCont } from './Tooltip.styles';
import { CaptionRegularL } from '../../styles/globals';

interface ITooltip {
  children: ReactElement;
  className?: string;
  tooltipDesc: ReactNode | Record<string, string>;
  position?: 'top' | 'bottom';
  positionX?: string;
  positionY?: string;
  arrowPositionX?: string;
  background?: string;
  width?: string;
}

const Tooltip: FC<ITooltip> = ({
  children,
  className,
  tooltipDesc,
  position = 'bottom',
  positionX,
  positionY,
  arrowPositionX,
  background,
  width,
}) => {
  const [active, setActive] = useState(false);
  const tooltipContent = useMemo(() => {
    if (tooltipDesc && typeof tooltipDesc === 'object' && !React.isValidElement(tooltipDesc)) {
      return Object.values(tooltipDesc)[0] || '';
    }

    return tooltipDesc;
  }, [tooltipDesc]);

  const renderTooltipBody = useMemo(
    () =>
      active && (
        <TooltipBody
          id="TooltipBody"
          data-testid="tooltipBody"
          width={width}
          position={position}
          positionX={positionX}
          positionY={positionY}
          background={background}
          arrowPositionX={arrowPositionX}
        >
          <CaptionRegularL id="CaptionRegularL" data-testid="tooltipBody">
            {tooltipContent}
          </CaptionRegularL>
        </TooltipBody>
      ),
    [tooltipContent, active]
  );
  return (
    <TooltipCont
      className={className}
      data-testid="TooltipCont"
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      {children}
      {renderTooltipBody}
    </TooltipCont>
  );
};

export default Tooltip;
